import * as ACTIONS from '../../actionTypes/priceMatrixActionTypes';

const initialState = null;

const hotelData = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.INIT_SUCCESS: {
      let selectedRoomGroup = null;
      const roomGroupsWithPrices = action.roomGroups?.some(
        (room) => room.priceBreakDowns,
      );

      if (action.roomGroups && roomGroupsWithPrices) {
        const availableRoomGroups = [...action.roomGroups].filter(
          (roomGroup) => roomGroup.priceBreakDowns !== null,
        );

        selectedRoomGroup =
          availableRoomGroups.find(
            (roomGroup) =>
              roomGroup.bookingEngineRoomGroupKey ===
              action.hotelData?.selectedRoomGroupKey,
          ) || availableRoomGroups[0];
      }

      return {
        ...action.hotelData,
        roomGroups: action.roomGroups,
        selectedRoomGroup,
        noPrices: !roomGroupsWithPrices,
      };
    }

    case ACTIONS.SELECT_ROOM_GROUP:
      return {
        ...state,
        selectedRoomGroup: action.roomGroup,
      };
    case ACTIONS.ADD_TO_CART_INIT:
    case ACTIONS.ADD_TO_CART_FAIL:
    case ACTIONS.ADD_TO_CART_SUCCESS:
      return {
        ...state,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export default hotelData;
